"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var react_intersection_observer_1 = require("react-intersection-observer");
var DocumentPageImage_1 = __importDefault(require("./DocumentPageImage"));
var DocumentPageInputs_1 = __importDefault(require("./DocumentPageInputs"));
var useStyles = styles_1.makeStyles({
    root: {
        position: 'relative',
        width: '100%',
    },
});
var DocumentPage = function (_a) {
    var actor = _a.actor, dataTid = _a["data-tid"], isAutosignActive = _a.isAutosignActive, onBecomeCurrent = _a.onBecomeCurrent, onChangeInput = _a.onChangeInput, onFocusInput = _a.onFocusInput, onImageLoadError = _a.onImageLoadError, onReachInputMaxLength = _a.onReachInputMaxLength, page = _a.page, pageHeight = _a.pageHeight, pageWidth = _a.pageWidth, scrollContainer = _a.scrollContainer;
    var imageUrl = page.imageUrl, inputs = page.inputs;
    var classes = useStyles();
    var _b = react_intersection_observer_1.useInView({
        root: scrollContainer,
        rootMargin: '0px 0px -50% 0px',
    }), ref = _b.ref, inView = _b.inView;
    react_1.useEffect(function () {
        if (inView)
            onBecomeCurrent();
    }, [inView]);
    return (react_1.default.createElement("div", { className: classes.root, "data-tid": dataTid, ref: ref },
        react_1.default.createElement(DocumentPageImage_1.default, { imageUrl: imageUrl, pageHeight: pageHeight, pageWidth: pageWidth, onImageLoadError: onImageLoadError }),
        inputs && (react_1.default.createElement(DocumentPageInputs_1.default, { actor: actor, onChangeInput: onChangeInput, onFocusInput: onFocusInput, onReachInputMaxLength: onReachInputMaxLength, inputs: inputs, isAutosignActive: isAutosignActive, pageHeight: pageHeight, pageWidth: pageWidth }))));
};
exports.default = DocumentPage;
//# sourceMappingURL=DocumentPage.js.map